import { motion } from "framer-motion";
import { agendar } from "./rubro";

// ---------------------------------------------------------------------------
// FINAL CTA — "El primer trabajo que recuperes paga el sistema."
// ---------------------------------------------------------------------------

export function HomeCta() {
  return (
    <section className="relative py-32 lg:py-[200px] overflow-hidden bg-[#08080A]">
      <div className="absolute inset-0 z-0 flex items-center justify-center pointer-events-none">
        <div className="w-[800px] h-[600px] bg-gradient-to-tr from-[#7C3AED] via-[#6366F1] to-[#FB7185] rounded-full blur-[120px] opacity-15" />
      </div>

      <motion.div
        className="relative z-20 mx-auto px-6 text-center"
        style={{ maxWidth: 800 }}
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-10%" }}
        transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
      >
        <h2
          className="text-[#FAFAFA] font-medium tracking-[-0.03em] leading-[1.05] mb-8"
          style={{ fontSize: "clamp(36px,5vw,64px)" }}
        >
          El primer trabajo que recuperes paga el sistema.
        </h2>
        <p
          className="text-[#A1A1AA] leading-[1.6] mb-12 mx-auto max-w-[600px]"
          style={{ fontSize: "clamp(18px,1.4vw,20px)" }}
        >
          Te mostramos cuentas reales funcionando y te decimos si CreceLocal
          sirve para tu negocio.
        </p>
        <div className="flex flex-col items-center gap-6 mb-8">
          <button
            onClick={() => agendar("Cierre - Agendar llamada")}
            className="bg-[#7C3AED] hover:bg-[#7C3AED]/90 hover:-translate-y-[2px] transition-all hover:shadow-[0_12px_32px_rgba(124,58,237,0.25)] font-medium rounded-[12px] text-[#FAFAFA] inline-flex items-center justify-center"
            style={{ padding: "18px 40px", fontSize: 18 }}
          >
            Agendar una llamada
          </button>
        </div>
        <p className="text-[#71717A] font-mono text-[12px] tracking-[0.08em] uppercase">
          15 minutos · Sin compromiso
        </p>
      </motion.div>
    </section>
  );
}
